import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root"
})

export class CharsGroupingService {

    checkOruncheckAll(index, event, lstChars) {

        if (lstChars[index].SubCharcteristics != null && lstChars[index].SubCharcteristics != "" && lstChars[index].SubCharcteristics != undefined)
            for (let i = 0; i < lstChars[index].SubCharcteristics.length; i++) {
                lstChars[index].SubCharcteristics[i].IsChecked = event.checked;
            }
        return lstChars;
    }

    checkOruncheckAllTemp(index, event, lstCharsTemp, lstChars) {
        let index1 = lstCharsTemp.findIndex(entry => {
            return entry.CharacteristicId === lstChars[index].CharacteristicId;
        });
        lstCharsTemp[index1].IsChecked = event.checked;
        lstCharsTemp[index1].IsIntermediate = lstChars[index].IsIntermediate;

        if (lstCharsTemp[index1].SubCharcteristics != null && lstCharsTemp[index1].SubCharcteristics != "" && lstCharsTemp[index1].SubCharcteristics != undefined)
            for (let i = 0; i < lstCharsTemp[index1].SubCharcteristics.length; i++) {
                lstCharsTemp[index1].SubCharcteristics[i].IsChecked = event.checked;
            }

        return lstCharsTemp;
    }

    checkOrUncheckMain(mainIndex, lstChars) {

        return this.checkOrUncheckAllSubMthd(lstChars, mainIndex);

    }


    checkOrUncheckMainTemp(mainIndex, lstCharsTemp, lstChars) {
        let index = lstCharsTemp.findIndex(entry => {
            return entry.CharacteristicId === lstChars[mainIndex].CharacteristicId;
        });

        if (lstChars[mainIndex].SubCharcteristics != null && lstChars[mainIndex].SubCharcteristics != "" && lstChars[mainIndex].SubCharcteristics != undefined)
            for (let item of lstChars[mainIndex].SubCharcteristics) {
                for (let item2 of lstCharsTemp[index].SubCharcteristics) {
                    if (item.CharacteristicId === item2.CharacteristicId) {
                        item2.IsChecked = item.IsChecked;
                    }
                }
            }

        return this.checkOrUncheckAllSubMthd(lstCharsTemp, index);

    }

    specialSearch(val, lstCharsTemp) {
        let lstChars = lstCharsTemp.filter(entry => {
            return entry.Name.toLowerCase().indexOf(val.toLowerCase()) === 0 || (entry.SubCharcteristics != null && entry.SubCharcteristics.find(item => item.Name.toLowerCase().indexOf(val.toLowerCase()) === 0))
        });
        return lstChars;
    }


    checkOrUncheckAllSubMthd(lstCharsGlobal, index) {
        let mainCount = 0;
        if (lstCharsGlobal[index].SubCharcteristics != null && lstCharsGlobal[index].SubCharcteristics != "" && lstCharsGlobal[index].SubCharcteristics != undefined)
            for (let i = 0; i < lstCharsGlobal[index].SubCharcteristics.length; i++) {
                if (lstCharsGlobal[index].SubCharcteristics[i].IsChecked)
                    mainCount = mainCount + 1;
            }
        if (mainCount == lstCharsGlobal[index].SubCharcteristics.length) {
            lstCharsGlobal[index].IsChecked = true;
            lstCharsGlobal[index].IsIntermediate = false;
        }
        else if (mainCount == 0) {
            lstCharsGlobal[index].IsChecked = false;
            lstCharsGlobal[index].IsIntermediate = false;
        }
        else
            lstCharsGlobal[index].IsIntermediate = true;

        return lstCharsGlobal;
    }

    checkOrUncheckAllForAnalysis(lstChars, lstCharsSrch) {
        for (let i = 0; i < lstChars.length; i++) {
            lstCharsSrch[i].IsChecked = lstChars[i].IsChecked;
        }

        return lstCharsSrch;
    }

}